import { render, staticRenderFns } from "./MediaFocus.vue?vue&type=template&id=4fab822c&scoped=true"
import script from "./MediaFocus.vue?vue&type=script&lang=js"
export * from "./MediaFocus.vue?vue&type=script&lang=js"
import style0 from "./MediaFocus.vue?vue&type=style&index=0&id=4fab822c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fab822c",
  null
  
)

export default component.exports